import React from 'react'
import { useTranslation } from 'react-i18next'

const TeamMember = ({ name, role }) => (
    <div className="col mb-5">
        <div className="text-center">
            <img className="img-fluid rounded-circle mb-4 px-4" src="https://dummyimage.com/150x150/ced4da/6c757d" alt={name} />
            <h5 className="fw-bolder">{name}</h5>
            <div className="fst-italic text-muted">{role}</div>
        </div>
    </div>
);
const SectionAbout = () => {
    const { t } = useTranslation();
    return (
        <>
            <section className="py-5 bg-light" id="scroll-target">
                <div className="container px-5 my-5">
                    <div className="row gx-5 align-items-center">
                        <div className="col-lg-6">
                            <img className="img-fluid rounded mb-5 mb-lg-0" src="https://dummyimage.com/600x400/343a40/6c757d" alt="..." />
                        </div>
                        <div className="col-lg-6">
                            <h2 className="fw-bolder">{t('about.foundationTitle')}</h2>
                            <p className="lead fw-normal text-muted mb-0">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto est, ut esse a labore aliquam beatae expedita. Blanditiis impedit numquam libero molestiae et fugit cupiditate, quibusdam expedita, mayores eaque quisquam.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5">
                <div className="container px-5 my-5">
                    <div className="row gx-5 align-items-center">
                        <div className="col-lg-6 order-first order-lg-last">
                            <img className="img-fluid rounded mb-5 mb-lg-0" src="https://dummyimage.com/600x400/343a40/6c757d" alt="..." />
                        </div>
                        <div className="col-lg-6">
                            <h2 className="fw-bolder">{t('about.growthTitle')}</h2>
                            <p className="lead fw-normal text-muted mb-0">
                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Iusto est, ut esse a labore aliquam beatae expedita. Blanditiis impedit numquam libero molestiae et fugit cupiditate, quibusdam expedita, mayores eaque quisquam.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 bg-light">
                <div className="container px-5 my-5">
                    <div className="text-center">
                        <h2 className="fw-bolder">{t('about.branchesTitle')}</h2>
                        <p className="lead fw-normal text-muted mb-5">{t('about.branchesSubtitle')}</p>
                    </div>
                    <div className="row gx-5 row-cols-1 row-cols-sm-2 row-cols-xl-4 justify-content-center">
                        <TeamMember name="Costa del Este" role="" />
                        <TeamMember name="Calidonia" role="" />
                        <TeamMember name="Chorrillo " role="" />
                        <TeamMember name="Altos de los Lagos" role="" />
                    </div>
                </div>
            </section>

        </>
    )
}

export default SectionAbout